import { ReactNode } from "react";
import { Lock } from "lucide-react";

/** Small lock + muted text. Used for the aggregate-privacy note and the
 *  Shared Receipts trust note. (The lock here is a NOTE affordance — never
 *  shown inside a Shared Receipts row.) */
export function TrustNote({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-start gap-2 text-xs text-muted-foreground px-1 pt-1">
      <Lock className="h-3.5 w-3.5 mt-0.5 shrink-0" aria-hidden />
      <span>{children}</span>
    </div>
  );
}
